/* Aristosil theme, stage 2 (19 Oct 2026): the static site's js/main.js (design v5, approved), ported onto Shopify.
   One file for every page; it binds only to what a page contains. Everything is an enhancement: with JS off every
   page is complete (links and forms post to Shopify's routes, the phone menu opens by :target, accordions are
   native <details>, gated parts are not rendered at all).

   What changed from the static file, and why:
   - The catalogue is the store's (snippets/aris-catalogue.liquid prints it as JSON), not a typed list.
   - The cart is Shopify's Ajax cart (/cart.js, /cart/add.js, /cart/change.js), not sessionStorage; the first state
     comes from the page (window.ARISTOSIL.cartInit, printed by the layout), so the count never flashes.
   - Gates are Theme settings rendered by Liquid; there is no ?gate= switch on a live store.
   - The pairing reads aristosil.pair_with and aristosil.pair_reason from the catalogue, not data/pairings.json.
   - Every visible line this file prints is a setting of sections/aris-drawers.liquid (#aris-strings).
   - The newsletter posts to Shopify (customer form); this file only checks the address first.
   - "For women" links go to the tag path /collections/<c>/women (no For filter in this store).

   Public surface, window.ARISTOSIL (A): catalogue, byHandle, inr, fmtDate, workingDays, waHref, dispatchBy,
   fillDates, gates, delivery, cart, wish, drawer, recent, t (the strings). Events on document: aristosil:cart
   {items, count, subtotal} after every cart change and once on load; aristosil:pin {pin}.
   Banned here as everywhere: urgency, invented counts, IntersectionObserver for sticky bars. No long dashes. */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  root.classList.add('js');

  var A = (window.ARISTOSIL = window.ARISTOSIL || {});
  A.whatsapp = A.whatsapp || { number: '' };
  A.dispatch = A.dispatch || { min: 1, max: 2, by: 'Dispatched by [date]' };
  A.routes = A.routes || {};
  var R = {
    root: A.routes.root || '/',
    cart: A.routes.cart || '/cart',
    add: (A.routes.cartAdd || '/cart/add') + '.js',
    change: (A.routes.cartChange || '/cart/change') + '.js',
    update: (A.routes.cartUpdate || '/cart/update') + '.js',
    search: A.routes.search || '/search'
  };
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function json(id) { var el = doc.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function icon(id) { return '<svg class="ico ico--s" aria-hidden="true"><use href="#i-' + id + '"/></svg>'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fill(s, map) { return String(s || '').replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; }); }
  function sget(store, k) { try { return JSON.parse(window[store].getItem(k)); } catch (e) { return null; } }
  function sset(store, k, v) { try { window[store].setItem(k, JSON.stringify(v)); } catch (e) { /* page still works */ } }

  /* ---------- Strings (sections/aris-drawers.liquid) and the catalogue (snippets/aris-catalogue.liquid) ---------- */
  var T = A.t = json('aris-strings') || {};
  function t(k, map) { return fill(T[k] || '', map || {}); }
  A.catalogue = json('aris-catalogue') || A.catalogue || [];
  var BY = {};
  A.catalogue.forEach(function (p) { BY[p.h] = p; });
  A.byHandle = function (h) { return BY[h] || null; };
  function productHref(h) { var c = BY[h]; return c && c.u ? c.u : R.root + 'products/' + h; }

  /* ---------- Helpers (the static main.js, unchanged) ---------- */
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  A.inr = function (n) { return (A.currency || '₹') + Math.round(n).toLocaleString('en-IN'); };
  A.fmtDate = function (d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; };
  A.workingDays = function (from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  };
  function waHref(text) { return 'https://wa.me/' + (A.whatsapp.number || '') + '?text=' + encodeURIComponent(text); }
  A.waHref = waHref;
  function waLink(label, text) { return '<a href="' + esc(waHref(text)) + '" target="_blank" rel="noopener">' + esc(label) + '</a>'; }
  A.gates = A.gates || [];
  function gateOn(n) { return A.gates.indexOf(n) > -1; }

  /* ---------- WhatsApp links: the number in one place ---------- */
  if (A.whatsapp.number) $all('[data-wa]').forEach(function (a) { a.href = waHref(a.getAttribute('data-wa-text') || 'Hi, I have a question about Aristosil'); });

  /* ---------- Dispatch date: his policy, dispatched within the most working days, shown as a date ---------- */
  A.dispatchBy = function () { return A.fmtDate(A.workingDays(new Date(), +A.dispatch.max || 2)); };
  function fillDates(rootEl) {
    var by = A.dispatchBy();
    $all('[data-dispatch-by]', rootEl).forEach(function (el) { el.textContent = by; });
    $all('[data-coll-dispatch]', rootEl).forEach(function (el) { el.textContent = String(A.dispatch.by || 'Dispatched by [date]').replace('[date]', by); });
  }
  A.fillDates = fillDates;
  fillDates(doc);

  /* ---------- Header: compact on scroll; the WhatsApp launcher after the first screen (phones) ---------- */
  var hdr = doc.querySelector('[data-hdr]');
  if (hdr) {
    var ticking = false;
    var wa = doc.querySelector('.wa-launch');
    var syncHdr = function () {
      ticking = false;
      hdr.classList.toggle('is-compact', window.scrollY > 24);
      if (wa) wa.classList.toggle('is-on', window.scrollY > window.innerHeight * 0.6);
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(syncHdr); } }, { passive: true });
    window.addEventListener('resize', function () { if (!ticking) { ticking = true; requestAnimationFrame(syncHdr); } });
    syncHdr();
  }

  /* ---------- Drawers (cart, saved): focus moves in, Esc and the veil close, focus returns ---------- */
  var veil = doc.querySelector('[data-veil]');
  var openName = null;
  var lastOpener = null;
  var INERT = ['.announce', '.hdr', 'main', '.ftr', '.wa-launch', '.totop'];
  function setInert(on) {
    INERT.forEach(function (sel) { $all(sel).forEach(function (el) { if (on) { el.setAttribute('inert', ''); } else { el.removeAttribute('inert'); } }); });
  }
  function drawerEl(name) { return doc.querySelector('[data-drawer="' + name + '"]'); }
  function focusables(el) {
    return $all('a[href], button:not([disabled]), input:not([type="hidden"]), textarea, summary, [tabindex]:not([tabindex="-1"])', el)
      .filter(function (x) { return x.offsetParent !== null || x === doc.activeElement; });
  }
  // 3 Nov, Omkar: "when side cart is open dont let the page in the back scroll". The root carries overflow-x: clip, so
  // body overflow never reached the viewport; the lock goes on <html> (aris-base.css), as the menu and search do.
  function lockPage() { doc.documentElement.classList.add('drawer-open'); }
  function unlockPage() { doc.documentElement.classList.remove('drawer-open'); }
  // 3 Nov, Omkar: "brown square around cart icon". Focus goes back to the opener when a drawer closes, and the ring
  // showed after a tap or click too. The ring now shows only while the visitor is using the keyboard.
  doc.addEventListener('pointerdown', function () { doc.documentElement.setAttribute('data-input', 'pointer'); }, true);
  doc.addEventListener('keydown', function (e) { if (e.key === 'Tab' || e.key.indexOf('Arrow') === 0) doc.documentElement.setAttribute('data-input', 'key'); }, true);
  A.drawer = {
    open: function (name, opener) {
      var el = drawerEl(name);
      if (!el) return false;
      if (openName && openName !== name) A.drawer.close(true);
      el.hidden = false;
      lastOpener = opener || doc.activeElement;
      requestAnimationFrame(function () { el.classList.add('is-open'); });
      if (veil) { veil.hidden = false; requestAnimationFrame(function () { veil.classList.add('is-on'); }); }
      doc.body.classList.add('has-drawer');
      lockPage();
      setInert(true);
      $all('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      openName = name;
      setTimeout(function () { el.focus({ preventScroll: true }); }, 30);
      return true;
    },
    close: function (silent) {
      if (!openName) return;
      var el = drawerEl(openName);
      el.classList.remove('is-open');
      if (veil) { veil.classList.remove('is-on'); veil.hidden = true; }
      doc.body.classList.remove('has-drawer');
      unlockPage();
      setInert(false);
      $all('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      openName = null;
      if (!silent && lastOpener && lastOpener.focus) lastOpener.focus({ preventScroll: true });
    }
  };
  doc.addEventListener('click', function (e) {
    var t0 = e.target.closest && e.target.closest('[data-cart-open], [data-drawer-close], [data-drawer-close-link], [data-wish-open]');
    if (!t0) return;
    if (t0.hasAttribute('data-cart-open')) { if (!drawerEl('cart')) return; e.preventDefault(); if (addedEl) addedEl.innerHTML = ''; A.drawer.open('cart', t0); }
    else if (t0.hasAttribute('data-wish-open')) { if (!drawerEl('wishlist')) return; e.preventDefault(); A.drawer.open('wishlist', t0); }
    else if (t0.hasAttribute('data-drawer-close')) { e.preventDefault(); A.drawer.close(); }
    else { A.drawer.close(true); }
  });
  if (veil) veil.addEventListener('click', function () { A.drawer.close(); });
  doc.addEventListener('keydown', function (e) {
    if (!openName) return;
    if (e.key === 'Escape') { A.drawer.close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(drawerEl(openName));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (doc.activeElement === first || doc.activeElement === drawerEl(openName))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  var cartEl = drawerEl('cart');
  if (cartEl) cartEl.hidden = false; // the side cart exists only with JS; without it the bag goes to /cart

  /* ---------- Search suggestions over the store's range ---------- */
  var SYN = {
    'Rings': 'ring rings band bands',
    'Earrings': 'earring earrings stud studs drop drops',
    'Bracelets': 'bracelet bracelets',
    'Chains and pendants': 'chain chains pendant pendants necklace necklaces',
    'Kadas': 'kada kadas bangle bangles cuff'
  };
  var GEN = { w: 'women woman her', m: 'men man him', u: 'men women unisex' };
  function norm(s) { return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  var INDEX = A.catalogue.map(function (p) { return norm(p.n + ' ' + p.c + ' ' + (SYN[p.c] || '') + ' ' + p.f + ' ' + (GEN[p.g] || '')); });
  function matchesFor(q) {
    var toks = norm(q).split(/\s+/).filter(Boolean);
    var out = [];
    A.catalogue.forEach(function (p, i) {
      var hay = ' ' + INDEX[i];
      if (toks.every(function (tk) { return hay.indexOf(' ' + tk) > -1; })) out.push(p);
    });
    return out.sort(function (a, b) { return a.p - b.p; });
  }
  function bindSearch(form, fi) {
    if (form.hasAttribute('data-search-bound')) return;
    form.setAttribute('data-search-bound', '');
    var input = form.querySelector('.search__input');
    var list = form.querySelector('.suggest');
    if (!input || !list) return;
    var active = -1;
    function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
    function opts() { return $all('[role="option"]', list); }
    function mark() {
      opts().forEach(function (o, i) { o.setAttribute('aria-selected', String(i === active)); });
      var cur = opts()[active];
      if (cur) { input.setAttribute('aria-activedescendant', cur.id); cur.scrollIntoView({ block: 'nearest' }); } else { input.removeAttribute('aria-activedescendant'); }
    }
    function render() {
      form.classList.toggle('has-value', input.value.length > 0);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      var m = matchesFor(q);
      var html = '';
      if (m.length) {
        m.slice(0, 6).forEach(function (p, i) {
          html += '<a class="suggest__item" role="option" id="sg' + fi + '-' + i + '" aria-selected="false" href="' + esc(productHref(p.h)) + '">' +
            '<span>' + esc(p.n) + '</span><span class="price">' + A.inr(p.p) + '</span>' +
            '<small>' + esc(p.c) + (p.f ? ' · ' + esc(p.f) : '') + (p.s ? '' : ' · ' + esc(T.sold || 'Sold out')) + '</small></a>';
        });
        html += '<a class="suggest__all" href="' + esc(R.search) + '?q=' + encodeURIComponent(q) + '&amp;type=product&amp;options%5Bprefix%5D=last">' + esc(t('suggestAll', { n: m.length, q: q })) + '</a>';
      } else {
        html = '<p class="suggest__empty">' + fill(esc(T.suggestNone || ''), { q: esc(q), wa: waLink(T.suggestWa || '', t('suggestWaText', { q: q })) }) + '</p>';
      }
      list.innerHTML = html;
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }
    input.addEventListener('input', render);
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2) render(); });
    input.addEventListener('keydown', function (e) {
      var o = opts();
      if (e.key === 'ArrowDown' && o.length) { e.preventDefault(); active = (active + 1) % o.length; mark(); }
      else if (e.key === 'ArrowUp' && o.length) { e.preventDefault(); active = (active - 1 + o.length) % o.length; mark(); }
      else if (e.key === 'Enter' && active > -1 && o[active]) { e.preventDefault(); o[active].click(); }
      else if (e.key === 'Escape') { close(); }
    });
    doc.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }
  $all('form[data-search]').forEach(bindSearch);

  /* ---------- Delivery window (D01, H05). The dispatch date is real (1 to 2 working days by his policy). The ARRIVAL
     range below is the static site's invented zone table (DUMMY-CONTENT 9.4) and runs ONLY behind Theme settings >
     Aristosil: gates > Courier arrival dates (A.courier, off until Shiprocket serviceability is connected); it is
     marked for replacement by Shiprocket's serviceability response. With the gate off the pincode is confirmed and
     the dispatch date printed, no arrival range (PDP pass, C09). ---------- */
  A.courier = !!(doc.querySelector('[data-courier="on"]'));
  var ZONES = [
    { re: /^5[0-3]/, d: 2 },
    { re: /^(11|40|56|60|70)/, d: 3 },
    { re: /^(18|19|7[89])/, d: 7 }
  ];
  function transitDays(pin) { for (var i = 0; i < ZONES.length; i++) { if (ZONES[i].re.test(pin)) return ZONES[i].d; } return 5; }
  function courierDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0) n--; } return x; }
  var PIN_KEY = 'aristosil-pin';
  A.delivery = {
    valid: function (v) { return /^[1-9][0-9]{5}$/.test(v || ''); },
    window: function (pin, from) {
      var tt = from || new Date(), n = transitDays(pin);
      var d1 = A.workingDays(tt, +A.dispatch.min || 1), d2 = A.workingDays(tt, +A.dispatch.max || 2);
      if (!A.courier) return { dispatch: d2, early: null, late: null };   // gate off: no arrival dates
      return { dispatch: d2, early: courierDays(d1, n), late: courierDays(d2, n) };
    },
    get: function () { var v = sget('localStorage', PIN_KEY); return A.delivery.valid(v) ? v : ''; },
    set: function (v) {
      if (!A.delivery.valid(v)) return;
      sset('localStorage', PIN_KEY, v);
      renderPin(false);
      try { doc.dispatchEvent(new CustomEvent('aristosil:pin', { detail: { pin: v } })); } catch (e) { /* old browser */ }
    }
  };

  /* ---------- Cart: Shopify's Ajax cart, at most 5 of a piece (static MAX_Q) ---------- */
  var MAX_Q = 5;
  var items = [];
  function fromShopify(c) {
    return ((c && c.items) || []).map(function (li) {
      var cat = BY[li.handle] || {};
      var img = cat.i || (li.image ? li.image + (li.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '');
      return { key: li.key, id: li.variant_id || li.id, h: li.handle, n: li.product_title || li.title, p: (li.final_price != null ? li.final_price : li.price) / 100,
        q: li.quantity, f: cat.f || '', img: img, s: cat.z && cat.z !== '?' ? cat.z : '', c: cat.c || li.product_type || '', r: cat.r == null ? 1 : cat.r };
    });
  }
  items = fromShopify(A.cartInit);
  function count() { return items.reduce(function (s, i) { return s + i.q; }, 0); }
  function subtotal() { return items.reduce(function (s, i) { return s + i.p * i.q; }, 0); }
  function emit() {
    try { doc.dispatchEvent(new CustomEvent('aristosil:cart', { detail: { items: items.slice(), count: count(), subtotal: subtotal() } })); } catch (e) { /* old browser */ }
  }
  function req(url, body) {
    return fetch(url, { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || (j && j.status && j.status >= 400)) { var er = new Error((j && (j.description || j.message)) || 'cart'); er.data = j; throw er; } return j; }); });
  }
  function refresh() {
    return req(R.cart + '.js').then(function (c) { items = fromShopify(c); renderCart(); emit(); return items; });
  }
  function track(ev, list) {
    window.dataLayer = window.dataLayer || [];
    var value = list.reduce(function (s, i) { return s + i.p * i.q; }, 0);
    // C11: item_id is the variant id (what the pixel and the channel apps key on), the handle rides as item_handle
    window.dataLayer.push({ event: ev, ecommerce: { currency: 'INR', value: value, items: list.map(function (i) { var c = BY[i.h]; return { item_id: String(i.id || (c && c.v) || i.h), item_handle: i.h, item_name: i.n, item_category: c ? c.c : '', item_variant: i.s || '', price: i.p, quantity: i.q }; }) } });
  }

  // the drawer's parts (markup in sections/aris-drawers.liquid)
  var foot = doc.querySelector('[data-cart-foot]');
  var addedEl = doc.querySelector('[data-cart-added]');
  var pinBox = doc.querySelector('[data-cart-pin]');
  var emptyX = cartEl ? cartEl.querySelector('.cart__recent') : null;
  var live = doc.querySelector('[data-cart-live]');
  function renderPin(edit) {
    if (!pinBox) return;
    var pin = A.delivery.get();
    if (pin && !edit) {
      var w = A.delivery.window(pin);
      var line = w.early ? fill(esc(T.pinArrives || ''), { early: '<strong>' + A.fmtDate(w.early) + '</strong>', late: '<strong>' + A.fmtDate(w.late) + '</strong>', pin: esc(pin) })
        : fill(esc(T.pinKnown || ''), { pin: esc(pin), dispatch: '<strong>' + A.fmtDate(w.dispatch) + '</strong>' });
      pinBox.innerHTML = '<p>' + line +
        ' <button class="cart__change" type="button" data-cart-pin-change>' + esc(T.pinChange || '') + '<span class="vh"> ' + esc((T.pinPlaceholder || '').toLowerCase()) + '</span></button></p>';
    } else {
      pinBox.innerHTML = '<form class="cart__pinf" novalidate><label class="vh" for="cart-pin">' + esc(T.pinLabel || '') + '</label>' +
        '<input class="input" id="cart-pin" type="text" inputmode="numeric" autocomplete="postal-code" maxlength="6" placeholder="' + esc(T.pinPlaceholder || '') + '" aria-describedby="cart-pin-msg" value="' + esc(pin) + '">' +
        '<button class="btn btn--secondary btn--card" type="submit">' + esc(T.pinButton || '') + '</button></form><p id="cart-pin-msg" role="status" aria-live="polite" data-cart-pin-msg></p>';
    }
  }
  if (pinBox) {
    pinBox.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = pinBox.querySelector('input');
      var msg = pinBox.querySelector('[data-cart-pin-msg]');
      var v = (inp.value || '').trim();
      if (!A.delivery.valid(v)) {
        inp.setAttribute('aria-invalid', 'true');
        msg.classList.add('is-error');
        msg.textContent = T.pinError || '';
        inp.focus();
        return;
      }
      A.delivery.set(v);
      var ch = pinBox.querySelector('[data-cart-pin-change]');
      if (ch) ch.focus();
    });
    pinBox.addEventListener('input', function (e) {
      var inp = e.target;
      if (!inp.matches || !inp.matches('input')) return;
      var v = inp.value.replace(/\D/g, '').slice(0, 6);
      if (v !== inp.value) inp.value = v;
      if (inp.getAttribute('aria-invalid') === 'true') { inp.removeAttribute('aria-invalid'); var m = pinBox.querySelector('[data-cart-pin-msg]'); m.classList.remove('is-error'); m.textContent = ''; }
    });
    pinBox.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cart-pin-change]')) return;
      renderPin(true);
      var inp = pinBox.querySelector('input');
      if (inp) { inp.focus(); inp.select(); }
    });
  }
  // H10 (gate gift): the message and the price-free invoice ride on the cart as attributes
  var giftBox = doc.querySelector('[data-cart-gift]');
  if (giftBox) {
    var gOn = giftBox.querySelector('[data-gift-on]'), gBody = giftBox.querySelector('[data-gift-body]');
    var gMsg = giftBox.querySelector('[data-gift-msg]'), gN = giftBox.querySelector('[data-gift-n]'), gNp = giftBox.querySelector('[data-gift-noprice]');
    var gT = null;
    gOn.checked = !!gMsg.value || giftBox.getAttribute('data-gift') === 'Yes';
    var gSync = function (save) {
      gBody.hidden = !gOn.checked; if (gN) gN.textContent = gMsg.value.length;
      if (!save) return;
      clearTimeout(gT);
      gT = setTimeout(function () {
        req(R.update, { attributes: { 'Gift': gOn.checked ? 'Yes' : '', 'Gift message': gOn.checked ? gMsg.value : '', 'Invoice without prices': gOn.checked && gNp.checked ? 'Yes' : '' } }).catch(function () { /* kept on the page */ });
      }, 500);
    };
    [gOn, gNp].forEach(function (x) { x.addEventListener('change', function () { gSync(true); }); });
    gMsg.addEventListener('input', function () { gSync(true); });
    gSync(false);
  }
  var co = doc.querySelector('[data-cart-foot] [data-checkout]');
  if (co) co.addEventListener('click', function () { track('begin_checkout', items); });

  function renderEmptyX() {
    if (!emptyX) return;
    var seen = A.recent.get().map(function (h) { return BY[h]; }).filter(function (c) { return c && c.s; }).slice(0, 4);
    emptyX.hidden = !seen.length;
    emptyX.innerHTML = seen.length ? '<p class="drawer__label">' + esc(T.recent || '') + '</p><ul class="cart__pair-list">' + seen.map(function (c) {
      return '<li><img src="' + esc(c.i) + '" width="56" height="70" alt="" loading="lazy"><p><a href="' + esc(productHref(c.h)) + '">' + esc(c.n) + '</a><small>' + A.inr(c.p) + (c.f ? ' · ' + esc(c.f) : '') + '</small></p></li>';
    }).join('') + '</ul>' : '';
  }
  function renderCart() {
    var n = count();
    $all('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-zero', n === 0); });
    $all('[data-cart-label]').forEach(function (el) {
      var b = el.closest('[data-t-one]');
      el.textContent = fill(b ? (n === 1 ? b.getAttribute('data-t-one') : b.getAttribute('data-t-many')) : 'Cart, [count] items', { count: n });
    });
    var lines = doc.querySelector('[data-cart-lines]');
    if (!lines) return;
    lines.innerHTML = items.map(function (i) {
      var meta = [i.f, i.s].filter(Boolean).map(esc).join(' · ') + (i.q > 1 ? (i.f || i.s ? ' · ' : '') + esc(t('each', { price: A.inr(i.p) })) : '');
      return '<li data-h="' + esc(i.h) + '" data-key="' + esc(i.key) + '">' +
        (i.img ? '<img src="' + esc(i.img) + '" width="76" height="95" alt="">' : '<span></span>') +
        '<p class="cart__line-name"><a href="' + esc(productHref(i.h)) + '">' + esc(i.n) + '</a></p>' +
        '<p class="cart__line-price">' + A.inr(i.p * i.q) + '</p>' +
        '<p class="cart__line-meta">' + meta + '</p>' +
        /* 3 Nov, Omkar: no not-returnable note on cart lines */
        '<div class="cart__line-ctrl"><div class="qty" role="group" aria-label="' + esc(t('qty', { name: i.n })) + '">' +
        '<button type="button" data-qty="-1" aria-label="' + esc(T.fewer || '') + '"' + (i.q <= 1 ? ' disabled' : '') + '>' + icon('minus') + '</button>' +
        '<output aria-live="polite">' + i.q + '</output>' +
        '<button type="button" data-qty="1" aria-label="' + esc(T.more || '') + '"' + (i.q >= MAX_Q ? ' disabled' : '') + '>' + icon('plus') + '</button>' +
        '</div><button class="cart__remove" type="button" data-remove>' + esc(T.remove || '') + '</button></div></li>';
    }).join('');
    renderPair();
    renderPin(false);
    renderEmptyX();
    $all('[data-cart-subtotal]').forEach(function (el) { el.textContent = A.inr(subtotal()); });
    var empty = doc.querySelector('[data-cart-empty]');
    if (empty) empty.hidden = n > 0;
    if (foot) foot.hidden = n === 0;
    if (giftBox) giftBox.hidden = n === 0;
  }
  // H06 the pinned pairing: the last-added piece's partner (aristosil.pair_with) with its reason, then one piece in
  // the same finish, gender compatible, another category first. Hidden when both are in the cart or sold out.
  function genderOk(a, b) { return !a || !b || a.g === 'u' || b.g === 'u' || a.g === b.g; }
  var pairCands = {};
  function renderPair() {
    var box = doc.querySelector('[data-cart-pair]');
    var list = doc.querySelector('[data-cart-pair-list]');
    if (!box || !list) return;
    var inCart = items.map(function (i) { return i.h; });
    var last = items[items.length - 1];
    var picks = [];
    if (last) {
      var lc = BY[last.h];
      var pc = lc && lc.pw ? BY[lc.pw] : null;
      if (pc && pc.s && inCart.indexOf(pc.h) < 0) picks.push({ c: pc, tag: '', why: '' });   /* 3 Nov: no reason line either; every card is name, price, polish */   /* 3 Nov, Omkar: no "Completes the set" label */
      if (last.f) {
        var same = A.catalogue.filter(function (p) {
          return p.s && p.f === last.f && p.h !== last.h && inCart.indexOf(p.h) < 0 && (!picks.length || p.h !== picks[0].c.h) && genderOk(lc, p);
        });
        same.sort(function (a, b) { return ((lc && a.c === lc.c) - (lc && b.c === lc.c)) || Math.abs(a.p - last.p) - Math.abs(b.p - last.p) || (a.h < b.h ? -1 : 1); });
        // 3 Nov, Omkar: "goes well with" as a sideways auto-scroll, so up to six pieces instead of two
        same.slice(0, 6 - picks.length).forEach(function (p) { picks.push({ c: p, tag: '', why: '' }); });   /* 3 Nov, Omkar: no "Also in ... polish" label on these cards */
      }
    }
    pairCands = {};
    picks.forEach(function (x) { pairCands[x.c.h] = { id: x.c.v, h: x.c.h, n: x.c.n, p: x.c.p, f: x.c.f, img: x.c.i }; });
    box.hidden = !items.length || !picks.length;
    list.innerHTML = picks.map(function (x) {
      var c = x.c;
      return '<li><img src="' + esc(c.i) + '" width="56" height="70" alt="" loading="lazy">' +
        '<p>' + (x.tag ? '<span class="cart__pair-tag">' + esc(x.tag) + '</span>' : '') + '<a href="' + esc(productHref(c.h)) + '">' + esc(c.n) + '</a>' +
        (x.why ? '<small class="cart__pair-why">' + esc(x.why) + '</small>' : '') + '<small>' + A.inr(c.p) + (x.why ? '' : (c.f ? ' · ' + esc(c.f) : '')) + '</small></p>' +
        '<button class="cart__pair-add" type="button" data-pair-add="' + esc(c.h) + '">' + icon('bag') + icon('plus') + '<span class="vh">' + esc(T.pairAdd || '') + ', ' + esc(c.n) + '</span></button></li>';
    }).join('');
  }
  A.cart = A.cart || {};
  A.cart.pairCandidates = function () { return pairCands; };
  var pairList = doc.querySelector('[data-cart-pair-list]');
  // The pairing row moves one card every 3.5 s and wraps to the start; it holds while touched, hovered or focused,
  // while the cart is closed, and never runs under reduced motion.
  if (pairList && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var pairHold = false, pairResume;
    var hold = function () { pairHold = true; clearTimeout(pairResume); };
    var release = function () { clearTimeout(pairResume); pairResume = setTimeout(function () { pairHold = false; }, 3000); };
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { pairList.addEventListener(ev, hold, { passive: true }); });
    ['pointerleave', 'touchend', 'focusout'].forEach(function (ev) { pairList.addEventListener(ev, release, { passive: true }); });
    setInterval(function () {
      if (pairHold || pairList.children.length < 2 || !pairList.offsetParent || doc.hidden) return;
      var step = pairList.children[0].getBoundingClientRect().width + 10;
      var max = pairList.scrollWidth - pairList.clientWidth;
      if (max <= 2) return;
      pairList.scrollTo({ left: pairList.scrollLeft + step > max + 2 ? 0 : pairList.scrollLeft + step, behavior: 'smooth' });
    }, 3500);
  }
  if (pairList) {
    pairList.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pair-add]');
      if (!b || !pairCands[b.getAttribute('data-pair-add')]) return;
      A.cart.add(pairCands[b.getAttribute('data-pair-add')]).then(function () {
        var c = cartEl && cartEl.querySelector('[data-drawer-close]');
        if (c) c.focus();
      }).catch(function () { /* the line stays as it was */ });
    });
  }
  function announce(html) { if (addedEl) addedEl.innerHTML = html ? icon('check') + '<span>' + html + '</span>' : ''; }
  function lineOf(keyOrHandle) { return items.filter(function (x) { return x.key === keyOrHandle || x.h === keyOrHandle; })[0]; }
  function setQty(keyOrHandle, q) {
    var it = lineOf(keyOrHandle);
    if (!it) return Promise.resolve(items);
    q = Math.max(0, Math.min(MAX_Q, Math.round(+q) || 0));
    return req(R.change, { id: it.key, quantity: q }).then(function (c) { items = fromShopify(c); renderCart(); emit(); return items; });
  }
  A.cart.items = function () { return items.slice(); };
  A.cart.open = function () { A.drawer.open('cart'); };
  A.cart.refresh = refresh;
  A.cart.announce = function (text) { announce(esc(text)); };
  A.cart.setQty = function (keyOrHandle, q) { return setQty(keyOrHandle, Math.max(1, +q || 1)); };
  A.cart.remove = function (keyOrHandle) { return setQty(keyOrHandle, 0); };
  // add({id, h, n, p, f, img, s, q}, {quiet}) -> Promise {q, capped}
  A.cart.add = function (it, opts) {
    var want = Math.max(1, +it.q || 1);
    var cat = BY[it.h] || {};
    var id = it.id || cat.v;
    var found = items.filter(function (x) { return String(x.id) === String(id); })[0];
    var room = MAX_Q - (found ? found.q : 0);
    var capped = want > room;
    var name = it.n || cat.n || '';
    var after = function () {
      var line = items.filter(function (x) { return String(x.id) === String(id); })[0] || { q: 0, s: it.s || '' };
      if (live) live.textContent = t('addedLive', { name: name });
      if (!(opts && opts.quiet)) {
        if (capped) {
          announce(fill(esc(T.capped || ''), { max: MAX_Q, name: esc(name), wa: waLink(T.cappedWa || '', t('cappedWaText', { max: MAX_Q, name: name })) }));
        } else {
          announce(esc(t('added', { name: name })) + (line.s || it.s ? ', ' + esc(line.s || it.s) : ''));
        }
      }
      return { q: line.q, capped: capped };
    };
    if (!id) return Promise.reject(new Error('no variant'));
    if (room <= 0) return Promise.resolve(after());
    return req(R.add, { items: [{ id: +id, quantity: Math.min(want, room) }] }).then(function () {
      track('add_to_cart', [{ h: it.h || cat.h, n: name, p: +it.p || cat.p || 0, s: it.s || '', q: Math.min(want, room) }]);
      return refresh();
    }).then(after);
  };
  var linesEl = doc.querySelector('[data-cart-lines]');
  if (linesEl) {
    linesEl.addEventListener('click', function (e) {
      var li = e.target.closest('li[data-key]');
      if (!li) return;
      var it = lineOf(li.getAttribute('data-key'));
      if (!it) return;
      var qb = e.target.closest('[data-qty]');
      if (qb) {
        var dir = qb.getAttribute('data-qty');
        setQty(it.key, Math.max(1, Math.min(MAX_Q, it.q + (+dir)))).then(function () {
          var nb = doc.querySelector('[data-cart-lines] li[data-h="' + it.h + '"] [data-qty="' + dir + '"]');
          if (nb && !nb.disabled) nb.focus();
        }).catch(function () { /* unchanged */ });
        return;
      }
      if (e.target.closest('[data-remove]')) {
        setQty(it.key, 0).then(function () {
          if (live) live.textContent = t('removedLive', { name: it.n });
          var c = cartEl && cartEl.querySelector('[data-drawer-close]');
          if (c) c.focus();
        }).catch(function () { /* unchanged */ });
      }
    });
  }

  // Add to cart from any card, buy box or bar: <form data-add> inside an element carrying data-product.
  // States (C03 to C05): idle; loading ("Adding", aria-busy, aria-disabled, a second tap ignored, the width held);
  // done ("Added") and the side cart opens with its first line; a refused add goes back to idle with an alert line
  // under the form and a WhatsApp route pre-filled with the piece and its size.
  function addError(form, host, size) {
    var name = host.getAttribute('data-name') || '';
    var el = host.querySelector('[data-add-error]');
    if (!el) {
      el = form.nextElementSibling && form.nextElementSibling.classList.contains('add-error') ? form.nextElementSibling : null;
      if (!el) { el = doc.createElement('p'); el.className = 'add-error'; el.setAttribute('role', 'alert'); form.parentNode.insertBefore(el, form.nextSibling); }
    }
    var own = el.getAttribute('data-error-text');
    var wat = fill(el.getAttribute('data-error-wa') || T.errorWaText || '', { name: name }) + (size ? ' (' + size + ')' : '');
    // 1 Nov 2026: without a WhatsApp number (Theme settings > Show WhatsApp off) the line ends after "Try again."
    var link = A.whatsapp.number ? '<a class="link" href="' + esc(waHref(wat)) + '" target="_blank" rel="noopener">' + esc(el.getAttribute('data-error-link') || T.errorWa || '') + '</a>' : '';
    // a block that carries its own words (the product page) prints "<text> <link>."; otherwise the drawer's line
    if (!link && own) own = own.replace(/,?\s*or\s*$/, '');
    var tpl = link ? (T.error || '') : (T.error || '').replace(/,?\s*or\s*\[wa\]/, '');
    el.innerHTML = own ? esc(own) + (link ? ' ' + link : '') + '.' : fill(esc(tpl), { wa: link });
    return el;
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-buy-now]');
    if (!b || !b.form) return;
    b.form.setAttribute('data-buy-now-click', '');
    setTimeout(function () { b.form.removeAttribute('data-buy-now-click'); }, 0);
  });
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-add]');
    if (!form || !window.fetch) return;
    // Buy now (PDP pass, C01/C11): a second submit button on the same form carrying return_to=/checkout; it posts
    // natively and Shopify sends the buyer to /checkout, where Razorpay Magic Checkout takes over. e.submitter is
    // Safari 15.4+; the click below marks the form for browsers without it, so the native post is never swallowed.
    if ((e.submitter && e.submitter.hasAttribute('data-buy-now')) || form.hasAttribute('data-buy-now-click')) return;
    var host = form.closest('[data-product]');
    var btn = form.querySelector('button[type="submit"]:not([data-buy-now])') || form.querySelector('button[type="submit"]');
    if (!host || !btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading') || btn.disabled) return;
    var label = btn.getAttribute('data-label') || btn.innerHTML;
    btn.setAttribute('data-label', label);
    btn.style.minWidth = btn.offsetWidth + 'px';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-disabled', 'true');
    btn.innerHTML = esc(T.adding || '') + '<span class="vh">, ' + esc(host.getAttribute('data-name')) + '</span>';
    var sizeIn = form.querySelector('input[name="size"]:checked');
    var size = sizeIn ? (sizeIn.getAttribute('data-size-text') || sizeIn.value) : (host.getAttribute('data-size') || '');
    var idIn = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var idle = function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.removeAttribute('aria-disabled'); };
    var err = host.querySelector('[data-add-error]') || (form.nextElementSibling && form.nextElementSibling.classList.contains('add-error') ? form.nextElementSibling : null);
    A.cart.add({
      id: (idIn && idIn.value) || host.getAttribute('data-variant-id'), h: host.getAttribute('data-handle'), n: host.getAttribute('data-name'),
      p: host.getAttribute('data-price'), f: host.getAttribute('data-finish'), img: host.getAttribute('data-img'), s: size,
      q: qtyInput ? Math.max(1, +qtyInput.value || 1) : 1
    }).then(function () {
      if (err) err.innerHTML = '';
      idle();
      btn.classList.add('is-done');
      btn.innerHTML = icon('check') + esc(T.done || '');
      A.drawer.open('cart', btn);
      setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = label; btn.style.minWidth = ''; }, 1600);
    }).catch(function () {
      idle();
      btn.innerHTML = label;
      btn.style.minWidth = '';
      addError(form, host, size);
    });
  });

  /* ---------- Saved pieces (wishlist): hearts toggle a handle in localStorage; nothing is sent anywhere ---------- */
  var WISH_KEY = 'aristosil-wish';
  function wishGet() { return (sget('localStorage', WISH_KEY) || []).filter(function (h) { return BY[h] || doc.querySelector('[data-handle="' + h + '"]'); }); }
  function wishSet(v) { sset('localStorage', WISH_KEY, v); renderWish(); }
  function wishHas(h) { return wishGet().indexOf(h) > -1; }
  function wishToggle(h) {
    var w = sget('localStorage', WISH_KEY) || [];
    if (w.indexOf(h) > -1) { w = w.filter(function (x) { return x !== h; }); } else { w.push(h); }
    wishSet(w);
    return w.indexOf(h) > -1;
  }
  function wishRecord(h) {
    var c = BY[h];
    if (c) return { h: c.h, n: c.n, p: c.p, f: c.f, img: c.i, v: c.v, s: c.s };
    var el = doc.querySelector('[data-handle="' + h + '"][data-name]');
    return el ? { h: h, n: el.getAttribute('data-name'), p: +el.getAttribute('data-price'), f: el.getAttribute('data-finish') || '', img: el.getAttribute('data-img'), v: el.getAttribute('data-variant-id'), s: 1 } : null;
  }
  function renderWish() {
    var w = wishGet(), n = w.length;
    $all('[data-wish-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-zero', n === 0); });
    $all('span[data-wish-label]').forEach(function (el) { el.textContent = t('wishLabel', { count: n }); });
    $all('[data-wish]').forEach(function (b) {
      var h = b.getAttribute('data-wish');
      var on = w.indexOf(h) > -1;
      var nm = (BY[h] && BY[h].n) || (b.closest('[data-name]') && b.closest('[data-name]').getAttribute('data-name')) || '';
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? t('wishRemove', { name: nm }) : t('wishSave', { name: nm }));
    });
    var lines = doc.querySelector('[data-wish-lines]');
    var empty = doc.querySelector('[data-wish-empty]');
    if (!lines) return;
    var recs = w.map(wishRecord).filter(Boolean);
    lines.innerHTML = recs.map(function (r) {
      return '<li' + (r.s ? ' data-product' : '') + ' data-handle="' + esc(r.h) + '" data-name="' + esc(r.n) + '" data-price="' + r.p + '" data-finish="' + esc(r.f || '') + '" data-img="' + esc(r.img) + '" data-variant-id="' + esc(r.v) + '">' +
        '<img src="' + esc(r.img) + '" width="76" height="95" alt="" loading="lazy">' +
        '<p><a href="' + esc(productHref(r.h)) + '">' + esc(r.n) + '</a><small>' + A.inr(r.p) + (r.f ? ' · ' + esc(r.f) : '') + '</small></p>' +
        '<button class="wish" type="button" data-wish="' + esc(r.h) + '" aria-pressed="true" aria-label="' + esc(t('wishRemove', { name: r.n })) + '">' + icon('heart') + '</button>' +
        (r.s ? '<form class="card__add" action="' + esc(R.root) + 'cart/add" method="post" data-add><input type="hidden" name="id" value="' + esc(r.v) + '"><button class="btn btn--secondary btn--card" type="submit">' + esc(T.cartAdd || '') + '<span class="vh">, ' + esc(r.n) + '</span></button></form>' : '<p class="card__sold-t">' + esc(T.sold || '') + '</p>') + '</li>';
    }).join('');
    if (empty) empty.hidden = n > 0;
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish');
    var on = wishToggle(h);
    var nm = (BY[h] && BY[h].n) || '';
    var st = doc.querySelector('.wishd [role="status"]');
    if (st) st.textContent = t(on ? 'wishSaved' : 'wishRemoved', { name: nm });
  });
  renderWish();
  A.wish = { get: wishGet, toggle: wishToggle, has: wishHas, render: renderWish };

  /* ---------- Recently viewed (the product page pushes; nothing shows on a first visit) ---------- */
  A.recent = {
    get: function () { return sget('localStorage', 'aristosil-recent') || []; },
    push: function (h) { var r = A.recent.get().filter(function (x) { return x !== h; }); r.unshift(h); sset('localStorage', 'aristosil-recent', r.slice(0, 8)); }
  };

  /* ---------- Tabs: one row of pills, one panel shown; arrow keys move between tabs; the href stays its collection ---------- */
  function bindTabs(scope) {
    $all('[data-tabs]', scope).forEach(function (list) {
      if (list.hasAttribute('data-tabs-bound')) return;
      list.setAttribute('data-tabs-bound', '');
      var tabs = $all('[data-tab]', list);
      var panels = $all('[data-tabpanel]', list.parentNode);
      function show(slug, focus) {
        tabs.forEach(function (tb) { var on = tb.getAttribute('data-tab') === slug; tb.classList.toggle('is-on', on); tb.setAttribute('aria-selected', String(on)); tb.setAttribute('tabindex', on ? '0' : '-1'); if (on && focus) tb.focus(); });
        panels.forEach(function (p) { p.classList.toggle('is-off', p.getAttribute('data-tabpanel') !== slug); });
      }
      tabs.forEach(function (tb, i) {
        tb.addEventListener('click', function (e) { e.preventDefault(); show(tb.getAttribute('data-tab')); });
        tb.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          show(tabs[(i + d + tabs.length) % tabs.length].getAttribute('data-tab'), true);
        });
      });
      var cur = tabs.filter(function (tb) { return tb.classList.contains('is-on'); })[0] || tabs[0];
      if (cur) show(cur.getAttribute('data-tab'));
    });
  }
  bindTabs(doc);

  /* ---------- Men or Women: the pick is kept for the session; the pills lead to that gender's pieces ---------- */
  function bindSeg(scope) {
    $all('[data-seg]', scope).forEach(function (seg) {
      var opts = $all('[data-seg-opt]', seg);
      var links = $all('[data-seg-links] a[data-cat]');
      var KEY = 'aristosil-seg-' + seg.getAttribute('data-seg');
      function apply(g) {
        opts.forEach(function (o) { o.setAttribute('aria-pressed', String(o.getAttribute('data-seg-opt') === g)); });
        links.forEach(function (a) {
          var c = a.getAttribute('data-cat');
          a.href = R.root + 'collections/' + (g ? (c === 'all' ? g : c + '/' + g) : c);
        });
      }
      opts.forEach(function (o) {
        o.addEventListener('click', function (e) {
          e.preventDefault();
          var g = o.getAttribute('data-seg-opt');
          var cur = sget('sessionStorage', KEY);
          g = cur === g ? '' : g;
          sset('sessionStorage', KEY, g);
          apply(g);
        });
      });
      apply(sget('sessionStorage', KEY) || '');
    });
  }
  bindSeg(doc);

  /* ---------- Footer: columns open from 900 px, accordions on phones ---------- */
  var fcols = $all('[data-fcol]');
  if (fcols.length && window.matchMedia) {
    var mq = window.matchMedia('(min-width: 900px)');
    var syncF = function () { fcols.forEach(function (d) { d.open = mq.matches; }); };
    syncF();
    if (mq.addEventListener) mq.addEventListener('change', syncF); else if (mq.addListener) mq.addListener(syncF);
  }

  /* ---------- Newsletter: the address is checked here, then Shopify's customer form takes it ---------- */
  $all('form[data-news], form.ftr__news').forEach(function (f) {
    var input = f.querySelector('input[type="email"]');
    var msg = f.querySelector('[role="status"]');
    if (!input || !msg) return;
    f.addEventListener('submit', function (e) {
      var v = (input.value || '').trim();
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
      input.setAttribute('aria-invalid', String(!ok));
      if (!ok) {
        e.preventDefault();
        msg.classList.remove('is-ok');
        msg.textContent = T.newsError || '';
        input.focus();
      }
    });
    input.addEventListener('input', function () { if (input.getAttribute('aria-invalid') === 'true') { input.removeAttribute('aria-invalid'); msg.textContent = ''; } });
  });

  /* ---------- First paint of the cart state, then the event every page script listens to ---------- */
  renderCart();
  emit();
  // a page restored from the back-forward cache carries a stale cart: read it again
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh().catch(function () { /* keep the old state */ }); });

  /* ---------- The theme editor re-renders a section in place: bind its parts again ---------- */
  doc.addEventListener('shopify:section:load', function (e) {
    fillDates(e.target);
    if (A.whatsapp.number) $all('[data-wa]', e.target).forEach(function (a) { a.href = waHref(a.getAttribute('data-wa-text') || ''); });
    $all('form[data-search]', e.target).forEach(bindSearch);
    bindTabs(e.target);
    bindSeg(e.target);
    renderWish();
  });
})();
